import 'slick-carousel';

const initSlickSlider = ($elem, options) => {
    $elem.slick(options);
};

export default initSlickSlider;
